// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.1_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/custom.css */
.DeviceDetailsOffCanvas_offcanvasWide__R04tB {
    width: 1200px !important; /* Adjust this value to your desired width */
  }
  
  @media (max-width: 768px) {
    .DeviceDetailsOffCanvas_offcanvasWide__R04tB {
      width: 100% !important; /* Full width on smaller screens */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Devices/DeviceDetailsOffCanvas.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,wBAAwB,EAAE,4CAA4C;EACxE;;EAEA;IACE;MACE,sBAAsB,EAAE,kCAAkC;IAC5D;EACF","sourcesContent":["/* src/styles/custom.css */\n.offcanvasWide {\n    width: 1200px !important; /* Adjust this value to your desired width */\n  }\n  \n  @media (max-width: 768px) {\n    .offcanvasWide {\n      width: 100% !important; /* Full width on smaller screens */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"offcanvasWide": `DeviceDetailsOffCanvas_offcanvasWide__R04tB`
};
export default ___CSS_LOADER_EXPORT___;
